import React from "react";
import TopNavbar from "../../components/topNavbar/TopNavbar";
import { connect } from "react-redux";
import Div100vh from "react-div-100vh";
import {
  CarouselCards,
  PageModalApp,
} from "../../components/PageApps/PageApps";
import PageCarousel from "../../components/Carousel/Carousel";
import PageHeader from "../pageHeader/PageHeader";
import FormikSDCForm from "../../components/SDC/SDCForm";
import SDCRegister from "../../components/SDC/SDCRegister";
import SupplierZoneSummary from "../../components/PageApps/SupplierZoneSummary";

class SupplierZone extends React.Component {
  constructor(props) {
    super(props);

    document.body.classList.add("project-viewer");
  }

  render() {
    return (
      <div style={{ overflowY: "auto" }}>
        <Div100vh>
          <TopNavbar />
          <PageHeader src="/water-bg.jpeg" alt="water-bg"></PageHeader>
          <SupplierZoneSummary />
          <br />
          <br />
          <div style={{ textAlign: "center" }}>
            <h1 style={{ fontWeight: "bold" }}>NEW Design Competency Apps</h1>
          </div>
          <section className="container develop-content pt-5" id="content">
            <div className="row align-items-center">
              <PageModalApp dataTarget="#SDCForm" src="/SDCForm.gif" />
              <div className="col-10">
                <h4 className="lead">@one Alliance Design Competency Form</h4>
                <p>
                  Any company wishing to undertake any design work on behalf of
                  the @one Alliance (excluding temporary works design) must
                  complete this form. It collects data on areas of design
                  competency, the implementation of quality procedures and
                  requires all companies to demonstrate a proven track record in
                  design.
                </p>
                <p>
                  All information submitted in the form will be reviewed by the
                  @one design team and if deemed acceptable, added to the Design
                  Competency Register.
                </p>
              </div>
              <FormikSDCForm />
            </div>
            <hr
              style={{
                color: "#6d7a80",
                backgroundColor: "#6d7a80",
                height: 2,
                borderColor: "#6d7a80",
              }}
            ></hr>
            <div className="row align-items-center">
              <PageModalApp dataTarget="#SDCRegister" src="/SDCRegister.gif" />
              <div className="col-10">
                <h4 className="lead">
                  @one Alliance Design Competency Register
                </h4>
                <p>
                  The register holds details of all companies approved to
                  complete design work on behalf of the @one Alliance (excluding
                  temporary works design).
                </p>
                <p>
                  The @one Alliance will search for suitable companies on the
                  register. Companies will then be contacted accordingly.
                </p>
                <p>
                  If your company is listed and your details need updating,
                  please contact oneengineering@anglianwater.co.uk
                </p>
              </div>
              <SDCRegister />
            </div>
            <hr
              style={{
                color: "#6d7a80",
                backgroundColor: "#6d7a80",
                height: 2,
                borderColor: "#6d7a80",
              }}
            ></hr>

            <div className="row"></div>
          </section>
          <br />
          <br />
          <div
            style={{
              textAlign: "center",
              backgroundColor: "lightBlue",
              paddingTop: "1rem",
            }}
          >
            <h1 style={{ margin: "0", fontWeight: "bold" }}>
              Procedures and guidance documents
            </h1>
          </div>
          <div
            className="d-flex justify-content-center row align-items-center"
            style={{ backgroundColor: "lightBlue" }}
          >
            <PageCarousel>
              <CarouselCards
                src="/SupplierZoneImages/DocManagement.jpg"
                alt="DocManagement"
                title="BIM 360 Docs |"
                titleDesc="ALL-PRO-BIM-001 Engineering Model and Documentation Control Procedure"
                description="Sets out how BIM 360 Docs should be used"
                link="https://docs.b360.eu.autodesk.com/projects/11292649-c2f5-44e0-89e3-de6895527115/folders/urn:adsk.wipemea:fs.folder:co.ywJtR0RuQW6_7TkZT2qXkQ/detail/viewer/items/urn:adsk.wipemea:dm.lineage:1vlsrMWwR2aQ0Ar1gs8MOw"
              />
              <CarouselCards
                src="/SupplierZoneImages/CQMarkup.jpg"
                alt="CQMarkups"
                title="BIM 360 Docs |"
                titleDesc="ALL-GUI-BIM-002 Managing and reviewing files in BIM 360 Docs"
                description="Tells you how to upload files, mark-up, submit files for review and subscribe to folders
"
                link="https://docs.b360.eu.autodesk.com/projects/11292649-c2f5-44e0-89e3-de6895527115/folders/urn:adsk.wipemea:fs.folder:co.ywJtR0RuQW6_7TkZT2qXkQ/detail/viewer/items/urn:adsk.wipemea:dm.lineage:4lKPfVBmSfWd_wMHis56eA"
              />
              <CarouselCards
                src="/SupplierZoneImages/CQIssues.jpg"
                alt="Issues"
                title="BIM 360 Docs |"
                titleDesc="ALL-GUI-BIM-003 Creating and managing issues in BIM 360 Docs"
                description="Explains how to create and manage issues (i.e Design Queries) in BIM 360 Docs"
                link="https://docs.b360.eu.autodesk.com/projects/11292649-c2f5-44e0-89e3-de6895527115/folders/urn:adsk.wipemea:fs.folder:co.ywJtR0RuQW6_7TkZT2qXkQ/detail/viewer/items/urn:adsk.wipemea:dm.lineage:nXGUoz2wQdugjtJnlGgBzA"
              />
              <CarouselCards
                src="/SupplierZoneImages/FileNaming.png"
                alt="File naming convention"
                title="File naming convention |"
                titleDesc="ALL-GUI-BIM-008 File naming and the use of suitability and revision codes in Engineering"
                description="Explains how you must name files and details how suitability and revision codes must be used"
                link="https://docs.b360.eu.autodesk.com/projects/11292649-c2f5-44e0-89e3-de6895527115/folders/urn:adsk.wipemea:fs.folder:co.bgy3SgOcTP6GBgKy8ndqqw/detail/viewer/items/urn:adsk.wipemea:dm.lineage:cVAQS_zEQJesSZJfWlqGRw"
              />
            </PageCarousel>
          </div>

          <div
            style={{
              textAlign: "center",
              paddingTop: "1rem",
            }}
          >
            <h1 style={{ margin: "0", fontWeight: "bold" }}>Training videos</h1>
          </div>
          <div className="d-flex justify-content-center">
            <PageCarousel>
              <CarouselCards
                src="/SupplierZoneImages/CQPV.jpg"
                alt="Project Viewer"
                title="Project Viewer |"
                titleDesc="3D Model Training"
                description="Explains how to navigate around and interpret 3D models in the Project Viewer"
                link="https://docs.b360.eu.autodesk.com/projects/11292649-c2f5-44e0-89e3-de6895527115/folders/urn:adsk.wipemea:fs.folder:co.ilGSSM9eQaCcN05MJDSA-A/detail/viewer/items/urn:adsk.wipemea:dm.lineage:fbWPAl5XT6Ky8UVmcf-jpA"
              />
              <CarouselCards
                src="/SupplierZoneImages/DocManagement2.jpg"
                alt="DocManagement2"
                title="BIM 360 Docs |"
                titleDesc="BIM 360 Docs file management training"
                description="A recording of a MS training session covering all BIM 360 Docs topics. Everything you need to know and more!"
                link="https://docs.b360.eu.autodesk.com/projects/11292649-c2f5-44e0-89e3-de6895527115/folders/urn:adsk.wipemea:fs.folder:co.lxvRNyWPR4u1J7cEroRSjQ/detail/viewer/items/urn:adsk.wipemea:dm.lineage:8NQy76niScCVv7Rhqy9e_w"
              />
              <CarouselCards
                src="/SupplierZoneImages/TV007.jpg"
                alt="TV007"
                title="BIM 360 Docs |"
                titleDesc="Training video 007"
                description="Explains how to upload documents and 3D model files onto BIM 360 Docs"
                link="https://docs.b360.eu.autodesk.com/projects/11292649-c2f5-44e0-89e3-de6895527115/folders/urn:adsk.wipemea:fs.folder:co.lxvRNyWPR4u1J7cEroRSjQ/detail/viewer/items/urn:adsk.wipemea:dm.lineage:nhk8jJ0rSvWP0Z9ThRRiYw"
              />
              <CarouselCards
                src="/SupplierZoneImages/TV008.jpg"
                alt="TV008"
                title="BIM 360 Docs |"
                titleDesc="Training video 008"
                description="Tells you how to create mark ups in BIM 360 Docs"
                link="https://docs.b360.eu.autodesk.com/projects/11292649-c2f5-44e0-89e3-de6895527115/folders/urn:adsk.wipemea:fs.folder:co.lxvRNyWPR4u1J7cEroRSjQ/detail/viewer/items/urn:adsk.wipemea:dm.lineage:b-8WQnkWTJuJxtbx0tj0YA"
              />
              <CarouselCards
                src="/SupplierZoneImages/TV009.jpg"
                alt="TV009"
                title="BIM 360 Docs |"
                titleDesc="Training video 009"
                description="Explains how to archive markups in BIM 360 Docs"
                link="https://docs.b360.eu.autodesk.com/projects/11292649-c2f5-44e0-89e3-de6895527115/folders/urn:adsk.wipemea:fs.folder:co.lxvRNyWPR4u1J7cEroRSjQ/detail/viewer/items/urn:adsk.wipemea:dm.lineage:1A9DXBG_RSKFjtbSky0UbQ"
              />
              <CarouselCards
                src="/SupplierZoneImages/TV010.jpg"
                alt="TV010"
                title="BIM 360 Docs |"
                titleDesc="Training video 010"
                description="Tells you how to submit files for review in BIM 360 Docs"
                link="https://docs.b360.eu.autodesk.com/projects/11292649-c2f5-44e0-89e3-de6895527115/folders/urn:adsk.wipemea:fs.folder:co.lxvRNyWPR4u1J7cEroRSjQ/detail/viewer/items/urn:adsk.wipemea:dm.lineage:R09Nn8kVSqWKlJc1uezw9w"
              />
              <CarouselCards
                src="/SupplierZoneImages/TV012.jpg"
                alt="TV012"
                title="BIM 360 Docs |"
                titleDesc="Training video 012"
                description="Watch this video to learn how to subscribe to folders in BIM 360 Docs"
                link="https://docs.b360.eu.autodesk.com/projects/11292649-c2f5-44e0-89e3-de6895527115/folders/urn:adsk.wipemea:fs.folder:co.lxvRNyWPR4u1J7cEroRSjQ/detail/viewer/items/urn:adsk.wipemea:dm.lineage:YvWlXoaHTW2436dl50anCg"
              />
              <CarouselCards
                src="/SupplierZoneImages/TV013.jpg"
                alt="TV013"
                title="BIM 360 Docs |"
                titleDesc="Training video 013"
                description="Gives an overview of how you can share, download and export files in BIM 360 Docs"
                link="https://docs.b360.eu.autodesk.com/projects/11292649-c2f5-44e0-89e3-de6895527115/folders/urn:adsk.wipemea:fs.folder:co.lxvRNyWPR4u1J7cEroRSjQ/detail/viewer/items/urn:adsk.wipemea:dm.lineage:1k1YxUs4R32mmjWQTiR0Gg"
              />
              <CarouselCards
                src="/SupplierZoneImages/CQIssues.jpg"
                alt="issues inc DQ and DCR"
                title="BIM 360 Docs |"
                titleDesc="Issues including DQs and DCRs"
                description="Tells you how to raise and manage Issues on BIM 360 Docs"
                link="https://docs.b360.eu.autodesk.com/projects/11292649-c2f5-44e0-89e3-de6895527115/folders/urn:adsk.wipemea:fs.folder:co.lxvRNyWPR4u1J7cEroRSjQ/detail/viewer/items/urn:adsk.wipemea:dm.lineage:X0dKlwieSoK3eiw4ukWM3g"
              />
            </PageCarousel>
          </div>
        </Div100vh>
      </div>
    );
  }
}

export default connect()(SupplierZone);
